export default __webpack_public_path__ + "static/media/Mophie.8b427ceb.svg";